import { createContext, useContext, useState, useEffect } from "react";

const WP_API = "/api/wp/wp-json";
const AuthContext = createContext(null);

export const TIER_OPEN     = 0;
export const TIER_LOGADO_G = 1;
export const TIER_1        = 2;
export const TIER_3        = 3;

export function AuthProvider({ children }) {
  const [user, setUser]       = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    try {
      const stored = localStorage.getItem("rr_auth");
      if (stored) setUser(JSON.parse(stored));
    } catch {}
    setLoading(false);
  }, []);

  const login = async (email, password) => {
    const res = await fetch(`${WP_API}/rr/v1/login`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email, password }),
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.message || "Erro ao fazer login");
    localStorage.setItem("rr_auth", JSON.stringify(data));
    setUser(data);
    return data;
  };

  const register = async (name, email, password) => {
    const res = await fetch(`${WP_API}/rr/v1/register`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ name, email, password }),
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.message || "Erro ao criar conta");
    localStorage.setItem("rr_auth", JSON.stringify(data));
    setUser(data);
    return data;
  };

  const logout = () => {
    localStorage.removeItem("rr_auth");
    setUser(null);
  };

  const tier = user ? user.tier : TIER_OPEN;

  return (
    <AuthContext.Provider value={{
      user,
      loading,
      login,
      register,
      logout,
      tier,
      isLoggedIn:   tier >= TIER_LOGADO_G,
      isSubscriber: tier >= TIER_1,
      isFullMagma:  tier >= TIER_3,
    }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
